import request from '@/utils/request'

let Fc_userApi = {

  /*用户房产列表*/
  list(data) {
    return request._post('/shop/plus.fc_user.Index/index', data);
},
/*添加用户房产*/
add(data) {
    return request._post('/shop/plus.fc_user.Index/add', data);
},
audit(data) {
    return request._post('/shop/plus.fc_user.Index/audit', data);
},
/*修改用户房产*/
edit(data) {
    return request._post('/shop/plus.fc_user.Index/edit', data);
},
/*删除用户房产*/
del(data) {
    return request._post('/shop/plus.fc_user.Index/del', data);
},
/*用户房产详情*/
detail(data) {
  return request._post('/shop/plus.fc_user.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.fc_user.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.fc_user.Setting/getSetting', data, errorback);
    },
}
export default Fc_userApi;



// WEBPACK FOOTER //
// ./src/api/fc_user.js